// import { useState, useEffect } from "react";
// import axios from "axios";
// import FormInput from "../../../components/input/FormInput";
// import "./KVSRegistrationForm.css";
// import { useNavigate } from "react-router-dom";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
// import { toast } from "react-toastify";

// // TODO: replace with your actual registration API endpoint
// const REGISTRATION_API_URL = webServiceUrl.cohortRegistration;

// const initialState = {
//   emailRecord: false,
//   email: "",
//   kvCode: "",
//   nameOfKV: "",
//   stateOfKV: "",
//   fullName: "",
//   educationQualification: "",
//   gender: "",
//   contactNo: "",
//   whatsappNo: "",
//   emergencyContactNo: "",
//   emailId: "",
//   bloodGroup: "",
//   dateOfArrival: "",
//   arrivalTime: "",
//   dateOfDeparture: "",
//   departureTime: "",
//   bringingLaptop: "",
//   hardwareKit: "",
//   bringingPhotos: "",
//   mealPreference: "",
//   relieving_Letter: null,
//   trainer: "",
// };

// const bloodGroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

// // Pull whatever the logged-in session has stored so we can pre-fill the form.
// // Adjust the key names below if your login/session object uses different fields.
// const getLoggedInUser = () => {
//   try {
//     const course = JSON.parse(localStorage.getItem("user"));
//     console.log(course, "dfgdfgeqwelij");
//     const student = course?.student;
//     return {
//       name: student?.name || "",
//       email: student?.email || course?.email || "",
//       contactNo: student?.contact_no || student?.mobile || "",
//       school_code: course?.school_code,
//     };
//   } catch {
//     return null;
//   }
// };

// export default function OnlineRegistrationForm() {
//   const [fields, setFields] = useState(initialState);
//   const [errors, setErrors] = useState({});
//   const [submitted, setSubmitted] = useState(false);
//   const [loggedInUser, setLoggedInUser] = useState(null);
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");
//   const navigate = useNavigate();
//   let phoneNumber = localStorage.getItem("phone");
//   let token = localStorage.getItem("token");
//   const [trainerUser, settrainerUser] = useState([]);
//   const getTrainer = async () => {
//     try {
//       let res = await axios.get(webServiceUrl.list_trainer, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       if (res.data.success) {
//         settrainerUser(res?.data?.data);
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   };

//   useEffect(() => {
//     getTrainer();
//   }, []);

//   function validate(fields) {
//     const errors = {};
//     if (!fields.email.trim()) errors.email = "Email is required.";
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))
//       errors.email = "Enter a valid email address.";
//     // if (!fields?.kvCode?.trim()) errors.kvCode = "School Code is required.";
//     // else if (!/^\d{3}$/.test(fields.kvCode))
//     //   errors.kvCode = "School Code must be exactly 3 digits.";
//     if (!fields.nameOfKV.trim()) errors.nameOfKV = "Name of KV is required.";
//     if (!fields.stateOfKV.trim())
//       errors.stateOfKV = "State of KV School is required.";
//     if (!fields.fullName.trim()) errors.fullName = "Full name is required.";
//     if (!fields.educationQualification.trim())
//       errors.educationQualification = "Education qualification is required.";
//     if (!fields.gender) errors.gender = "Please select a gender.";
//     if (!fields.contactNo.trim())
//       errors.contactNo = "Contact number is required.";
//     else if (!/^\d{10}$/.test(fields.contactNo))
//       errors.contactNo = "Contact number must be 10 digits.";
//     if (!fields.whatsappNo.trim())
//       errors.whatsappNo = "WhatsApp number is required.";
//     else if (!/^\d{10}$/.test(fields.whatsappNo))
//       errors.whatsappNo = "WhatsApp number must be 10 digits.";
//     if (!fields.emergencyContactNo.trim())
//       errors.emergencyContactNo = "Emergency contact number is required.";
//     else if (!/^\d{10}$/.test(fields.emergencyContactNo))
//       errors.emergencyContactNo = "Emergency contact must be 10 digits.";
//     if (!fields.emailId.trim()) errors.emailId = "Email ID is required.";
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.emailId))
//       errors.emailId = "Enter a valid email ID.";
//     if (!fields.bloodGroup) errors.bloodGroup = "Blood group is required.";
//     if (!fields.dateOfArrival)
//       errors.dateOfArrival = "Date of arrival is required.";
//     if (!fields.arrivalTime) errors.arrivalTime = "Arrival time is required.";
//     if (!fields.dateOfDeparture)
//       errors.dateOfDeparture = "Date of departure is required.";
//     if (!fields.departureTime)
//       errors.departureTime = "Departure time is required.";
//     if (!fields.hardwareKit)
//       errors.hardwareKit = "Please select hardware kit option.";
//     if (!fields.mealPreference.length === 0)
//       errors.mealPreference = "Please select a meal preference.";
//     if (!fields.trainer) errors.trainer = "Please select trainer.";
//     // if (!fields.relieving_Letter)
//     //   errors.relieving_Letter = "Please attach the Relieving Letter";

//     return errors;
//   }
//   // Auto-fill from the logged-in session on first load, so the teacher
//   // doesn't have to retype details already known from login.
//   useEffect(() => {
//     const user = getLoggedInUser();
//     if (!user) return;
//     setLoggedInUser(user);
//     setFields((f) => ({
//       ...f,
//       nameOfKV: f.fullName || user.name,
//       email: f.email,
//       emailId: f.emailId || user.email,
//       contactNo: f.contactNo || phoneNumber,
//       whatsappNo: f.whatsappNo || user.contactNo,
//       kvCode: f.school_code || user.school_code,
//     }));
//   }, []);

//   const set = (key) => (value) => {
//     console.log(key, value);
//     setFields((f) => ({ ...f, [key]: value }));
//     setErrors((e) => ({ ...e, [key]: undefined }));
//   };

//   const toggleMeal = (val) => {
//     console.log(val);
//     setFields((f) => {
//       const prev = f.mealPreference;
//       return {
//         ...f,
//         mealPreference: val,
//       };
//     });
//     setErrors((e) => ({ ...e, mealPreference: undefined }));
//   };

//   const handleSubmit = async () => {
//     // setSubmitted(true);
//     const errs = validate(fields);
//     if (Object.keys(errs).length > 0) {
//       setErrors(errs);
//       const firstKey = Object.keys(errs)[0];
//       const el = document.getElementById(firstKey);
//       if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
//       return;
//     }

//     setSubmitError("");
//     setSubmitting(true);

//     try {
//       const token = localStorage.getItem("token");
//       // Field names below match the API payload you shared (Key column).
//       const formData = new FormData();
//       formData.append("fullName", fields.fullName);
//       formData.append("gender", fields.gender == "Male" ? "M" : "F");
//       formData.append("bloodGroup", fields.bloodGroup);
//       formData.append("emailId", fields.emailId);
//       formData.append("contactNo", fields.contactNo);
//       formData.append("whatsappNo", fields.whatsappNo);
//       formData.append("emergencyContactNo", fields.emergencyContactNo);
//       formData.append("state", fields.stateOfKV);
//       formData.append("arrival_date", fields.dateOfArrival);
//       formData.append("arrival_time", fields.arrivalTime);
//       // formData.append("address", "address");
//       // formData.append("city", "dehli");
//       formData.append("departure_date", fields.dateOfDeparture);
//       formData.append("departure_time", fields.departureTime);
//       formData.append("bringing_laptop", fields.bringingLaptop === "Yes");
//       formData.append("hardware_kit", "yes");
//       formData.append(
//         "trainer",
//         trainerUser?.filter((item) => item?.name == fields.trainer)[0]
//           .employee_id,
//       );
//       formData.append(
//         "meal_preference",
//         Array.isArray(fields.mealPreference)
//           ? fields.mealPreference.join(",").toLowerCase()
//           : String(fields.mealPreference).toLowerCase(),
//       );
//       formData.append("bring_two_photos", fields.bringingPhotos === "Yes");
//       // if (fields.relieving_Letter) {
//       //   formData.append("relieving-letter", fields.relieving_Letter);
//       // }

//       console.log(
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//         REGISTRATION_API_URL,
//       );
//       const response = await axios.post(REGISTRATION_API_URL, formData, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response?.data?.success) {
//         localStorage.setItem("login", "true");
//         navigate("/");
//       } else {
//         toast.error("Registration failed. Please try again.");
//         setSubmitError(
//           response?.data?.message || "Registration failed. Please try again.",
//         );
//       }
//     } catch (err) {
//       console.log("Registration failed:", err.message);
//       toast.error(err.message);
//       setSubmitError(
//         err?.response?.data?.message ||
//           err.message ||
//           "Registration failed. Please try again.",
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleClear = () => {
//     setFields(initialState);
//     setErrors({});
//     setSubmitted(false);
//     setSubmitError("");
//   };

//   if (submitted) {
//     return (
//       <div className="online-page">
//         <div className="online-success-card">
//           <div className="online-success-icon">✓</div>
//           <h2 className="online-success-title">Registration Submitted!</h2>
//           <p className="online-success-text">
//             A copy of your responses will be emailed to support@ihfc.co.in.
//           </p>
//           <div className="online-success-details">
//             <p>
//               <strong>Name:</strong> {fields.fullName}
//             </p>
//             <p>
//               <strong>School Code:</strong> {fields.kvCode}
//             </p>
//             <p>
//               <strong>KV Name:</strong> {fields.nameOfKV}
//             </p>
//             <p>
//               <strong>Training Dates:</strong> June 23rd to 27th 2025
//             </p>
//             <p>
//               <strong>Venue:</strong> MMTTC, JNU, New Delhi
//             </p>
//           </div>
//           <button className="online-clear-btn" onClick={handleClear}>
//             Submit Another Response
//           </button>
//         </div>
//       </div>
//     );
//   }

//   let local = localStorage.getItem("user");
//   console.log(JSON.parse(local), "pressings");

//   return (
//     <div className="online-page">
//       {/* Logged-in session banner */}

//       {/* Title Card */}
//       <div className="online-title-card">
//         <h1 className="online-form-title">
//           PM SHRI online ({JSON.parse(local)?.school_name})
//         </h1>
//         <div className="online-info-grid">
//           {/* <InfoRow label="Dates" value="Feb, 23rd to 27th 2026" /> */}
//           {/* <InfoRow
//             label="For"
//             value="PGT (PHY) teachers: Delhi and Gurgaon Region"
//           /> */}
//           {/* <InfoRow label="Training Dates" value="June, 23rd to 27th 2025" />
//           <InfoRow label="Duration" value="5 days" />
//           <InfoRow
//             label="Venue"
//             value="Malaviya Mission Teacher Training Centre (MMTTC), Jawaharlal Nehru University (JNU), New Delhi"
//           /> */}
//         </div>
//         <div className="online-mandatory-box">
//           <p className="online-mandatory-title">
//             📋 Please bring the following mandatory items:
//           </p>
//           <ol className="online-mandatory-list">
//             <li>Hardware Kit as given in the prerequisites link</li>
//             <li>Laptop</li>
//             <li>Two Passport Size photos for ID card</li>
//           </ol>
//         </div>
//         <p className="online-note-text">
//           <strong>Note:</strong> Due to limited accommodation, spouses and
//           children are not permitted.
//         </p>
//       </div>

//       <p className="online-required-note">* Indicates required question</p>

//       <div className="online-card-grid">
//         {/* Email input */}
//         <div className="online-card">
//           <FormInput
//             id="email"
//             type="email"
//             label="Email"
//             required
//             // disabled
//             placeholder="Your email"
//             value={fields.email}
//             onChange={set("email")}
//             error={errors.email}
//           />
//         </div>

//         {/* School Code */}
//         <div className="online-card">
//           <FormInput
//             id="kvCode"
//             type="text"
//             label="School Code (3 Digit Code)"
//             required
//             disabled
//             placeholder="Your answer"
//             maxLength={4}
//             value={fields.kvCode}
//             onChange={set("kvCode")}
//             error={errors.kvCode}
//           />
//         </div>

//         {/* Name of KV */}
//         <div className="online-card">
//           <FormInput
//             id="nameOfKV"
//             type="text"
//             label="Name"
//             required
//             disabled
//             placeholder="Your answer"
//             value={fields.nameOfKV}
//             onChange={set("nameOfKV")}
//             error={errors.nameOfKV}
//           />
//         </div>

//         {/* State of KV School */}
//         <div className="online-card">
//           <FormInput
//             id="stateOfKV"
//             type="text"
//             label="State of the School"
//             required
//             placeholder="Your answer"
//             value={fields.stateOfKV}
//             onChange={set("stateOfKV")}
//             error={errors.stateOfKV}
//           />
//         </div>

//         {/* Full Name */}
//         <div className="online-card">
//           <FormInput
//             id="fullName"
//             type="text"
//             label="Full name as per Service record"
//             required
//             placeholder="Your answer"
//             value={fields.fullName}
//             onChange={set("fullName")}
//             error={errors.fullName}
//           />
//         </div>

//         {/* Education Qualification */}
//         <div className="online-card">
//           <FormInput
//             id="educationQualification"
//             type="text"
//             label="Education Qualification with Specialization"
//             required
//             placeholder="Your answer"
//             value={fields.educationQualification}
//             onChange={set("educationQualification")}
//             error={errors.educationQualification}
//           />
//         </div>

//         {/* Gender */}
//         <div className="online-card">
//           <FormInput
//             id="gender"
//             type="select"
//             label="Gender"
//             required
//             options={["Male", "Female", "Transgender"]}
//             value={fields.gender}
//             onChange={set("gender")}
//             error={errors.gender}
//           />
//         </div>

//         {/* Contact No */}
//         <div className="online-card">
//           <FormInput
//             id="contactNo"
//             type="tel"
//             label="Contact no"
//             required
//             placeholder="Your answer"
//             maxLength={10}
//             value={fields.contactNo}
//             disabled
//             onChange={set("contactNo")}
//             error={errors.contactNo}
//           />
//         </div>

//         {/* WhatsApp No */}
//         <div className="online-card">
//           <FormInput
//             id="whatsappNo"
//             type="tel"
//             label="Whatsapp No"
//             required
//             placeholder="Your answer"
//             maxLength={10}
//             value={fields.whatsappNo}
//             onChange={set("whatsappNo")}
//             error={errors.whatsappNo}
//           />
//         </div>

//         {/* Emergency Contact */}
//         <div className="online-card">
//           <FormInput
//             id="emergencyContactNo"
//             type="tel"
//             label="Emergency Contact No."
//             required
//             placeholder="Your answer"
//             maxLength={10}
//             value={fields.emergencyContactNo}
//             onChange={set("emergencyContactNo")}
//             error={errors.emergencyContactNo}
//           />
//         </div>

//         {/* Email ID */}
//         <div className="online-card">
//           <FormInput
//             id="emailId"
//             type="email"
//             label="Email ID"
//             required
//             placeholder="Your answer"
//             value={fields.emailId}
//             onChange={set("emailId")}
//             error={errors.emailId}
//           />
//         </div>

//         {/* Blood Group */}
//         <div className="online-card">
//           <FormInput
//             id="bloodGroup"
//             type="select"
//             label="Blood Group"
//             required
//             options={bloodGroups}
//             value={fields.bloodGroup}
//             onChange={set("bloodGroup")}
//             error={errors.bloodGroup}
//           />
//         </div>

//         {/* Date of Arrival */}
//         <div className="online-card">
//           <FormInput
//             id="dateOfArrival"
//             type="date"
//             label="Date of Arrival at the Venue"
//             required
//             value={fields.dateOfArrival}
//             onChange={set("dateOfArrival")}
//             error={errors.dateOfArrival}
//           />
//         </div>

//         {/* Arrival Time */}
//         <div className="online-card">
//           <FormInput
//             id="arrivalTime"
//             type="time"
//             label="Arrival Time at the Venue"
//             required
//             value={fields.arrivalTime}
//             onChange={set("arrivalTime")}
//             error={errors.arrivalTime}
//           />
//         </div>

//         {/* Date of Departure */}
//         <div className="online-card">
//           <FormInput
//             id="dateOfDeparture"
//             type="date"
//             label="Date of Departure from the Venue"
//             required
//             value={fields.dateOfDeparture}
//             onChange={set("dateOfDeparture")}
//             error={errors.dateOfDeparture}
//           />
//         </div>

//         {/* Departure Time */}
//         <div className="online-card">
//           <FormInput
//             id="departureTime"
//             type="time"
//             label="Departure Time from the Venue"
//             required
//             value={fields.departureTime}
//             onChange={set("departureTime")}
//             error={errors.departureTime}
//           />
//         </div>

//         {/* Bringing Laptop */}
//         <div className="online-card">
//           <FormInput
//             id="bringingLaptop"
//             type="select"
//             label="I am bringing Laptop"
//             required
//             options={["Yes", "No"]}
//             value={fields.bringingLaptop}
//             onChange={set("bringingLaptop")}
//           />
//         </div>

//         {/* Hardware Kit */}
//         <div className="online-card">
//           <FormInput
//             id="hardwareKit"
//             type="select"
//             label="I am bringing the Hardware kit as shared in prerequisites list"
//             required
//             options={["Yes", "I will purchase at the Training Centre"]}
//             value={fields.hardwareKit}
//             onChange={set("hardwareKit")}
//             error={errors.hardwareKit}
//           />
//         </div>

//         {/* Bringing Photos */}
//         <div className="online-card">
//           <FormInput
//             id="bringingPhotos"
//             type="select"
//             label="I am bringing two passport size photos"
//             required
//             options={["Yes", "No"]}
//             value={fields.bringingPhotos}
//             onChange={set("bringingPhotos")}
//           />
//         </div>

//         {/* Meal Preference */}
//         <div className="online-card">
//           <div id="mealPreference">
//             <FormInput
//               type="select"
//               id="mealPreference"
//               label="Meal Preference"
//               required
//               options={["Veg", "Non-Veg"]}
//               value={fields.mealPreference}
//               onChange={(data) => toggleMeal(data)}
//             />
//           </div>
//           {errors.mealPreference && (
//             <p className="online-meal-error">{errors.mealPreference}</p>
//           )}
//         </div>
//         <div className="online-card">
//           <div id="relieving_Letter">
//             <FormInput
//               type="image"
//               label="Relieving Letter"
//               value={fields.relieving_Letter}
//               onChange={set("relieving_Letter")}
//             />
//           </div>
//           {errors.relieving_Letter && (
//             <p className="online-meal-error">{errors.relieving_Letter}</p>
//           )}
//         </div>
//         <div className="online-card">
//           <FormInput
//             id="trainer"
//             type="select"
//             label="Select Trainer"
//             required
//             options={trainerUser.map((item) => item.name)}
//             value={fields.trainer}
//             onChange={set("trainer")}
//           />
//         </div>
//       </div>

//       {submitError && (
//         <p className="online-meal-error" style={{ textAlign: "center" }}>
//           {submitError}
//         </p>
//       )}

//       {/* Submit */}
//       <p className="online-copy-note">
//         A copy of your responses will be emailed to support@ihfc.co.in.
//       </p>
//       <div className="online-submit-row">
//         <button
//           className="online-submit-btn"
//           onClick={handleSubmit}
//           disabled={submitting}
//         >
//           {submitting ? "Submitting..." : "Submit"}
//         </button>
//         <button
//           className="online-clear-btn"
//           onClick={handleClear}
//           disabled={submitting}
//         >
//           Clear form
//         </button>
//       </div>

//       <p className="online-footer">
//         Never submit passwords through Google Forms.
//       </p>
//     </div>
//   );
// }

// function InfoRow({ label, value }) {
//   return (
//     <p className="online-info-row">
//       <strong>{label}:</strong> {value}
//     </p>
//   );
// }

import { useState, useEffect } from "react";
import axios from "axios";
import FormInput from "../../../components/input/FormInput";
import "./KVSRegistrationForm.css";
import { useNavigate } from "react-router-dom";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast } from "react-toastify";

// TODO: replace with your actual registration API endpoint
const REGISTRATION_API_URL = webServiceUrl.cohortRegistration;

const initialState = {
  emailRecord: false,
  email: "",
  kvCode: "",
  nameOfKV: "",
  stateOfKV: "",
  fullName: "",
  educationQualification: "",
  gender: "",
  contactNo: "",
  whatsappNo: "",
  emergencyContactNo: "",
  emailId: "",
  bloodGroup: "",
  dateOfArrival: "",
  arrivalTime: "",
  dateOfDeparture: "",
  departureTime: "",
  bringingLaptop: "",
  hardwareKit: "",
  bringingPhotos: "",
  mealPreference: "",
  relieving_Letter: null,
  level: "",
  domain: "",   // this is the "class" (TGT/PGT) from get-domain
  course: ""
};

const bloodGroups = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

// Pull whatever the logged-in session has stored so we can pre-fill the form.
// Adjust the key names below if your login/session object uses different fields.
const getLoggedInUser = () => {
  try {
    const course = JSON.parse(localStorage.getItem("user"));
    console.log(course, "dfgdfgeqwelij");
    const student = course?.student;
    return {
      name: student?.name || "",
      email: student?.email || course?.email || "",
      contactNo: student?.contact_no || student?.mobile || "",
      school_code: course?.school_code,
    };
  } catch {
    return null;
  }
};

export default function OnlineRegistrationForm() {
  const [fields, setFields] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const navigate = useNavigate();
  let phoneNumber = localStorage.getItem("phone");
  let token = localStorage.getItem("token");
  const [trainerUser, settrainerUser] = useState([]);
  const [categories, setCategories] = useState([])
  const [domains, setDomains] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loadingDomains, setLoadingDomains] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(false);

  const getTrainer = async () => {
    try {
      let res = await axios.get(webServiceUrl.list_trainer, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        settrainerUser(res?.data?.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getCategories = async () => {
    try {
      const res = await axios.get(webServiceUrl.fetch_categories, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      if (res.data.success) {
        setCategories(res.data.data)
      }
    } catch (error) {
      console.error("Failed to Failed Categories.", error)
    }
  }

  const getDomain = async (level) => {
    setLoadingDomains(true);
    try {
      const res = await axios.post(
        webServiceUrl.get_domain,
        { level },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setDomains(res.data.data); // [{ class: "TGT" }, { class: "PGT" }]
      }
    } catch (e) {
      console.error("Failed to fetch domains", e);
      setDomains([]);
    } finally {
      setLoadingDomains(false);
    }
  };

  const getCourse = async (level, cls) => {
    setLoadingCourses(true);
    try {
      const res = await axios.post(
        webServiceUrl.get_course,
        { level, class: cls },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        setCourses(res.data.data); // [{ combination_code, course_list }]
      }
    } catch (e) {
      console.error("Failed to fetch courses", e);
      setCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

  const handleLevelChange = (val) => {
    setFields((f) => ({ ...f, level: val, domain: "", course: "" }));
    setErrors((e) => ({ ...e, level: undefined }));
    setCourses([]);
    if (val) {
      getDomain(val);
    } else {
      setDomains([]);
    }
  };

  const handleDomainChange = (val) => {
    setFields((f) => ({ ...f, domain: val, course: "" }));
    setErrors((e) => ({ ...e, domain: undefined }));
    if (val && fields.level) {
      getCourse(fields.level, val);
    } else {
      setCourses([]);
    }
  };

  useEffect(() => {
    getTrainer();
    getCategories();
  }, []);

  function validate(fields) {
    const errors = {};
    if (!fields.email.trim()) errors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))
      errors.email = "Enter a valid email address.";
    if (!fields?.kvCode?.trim()) errors.kvCode = "School Code is required.";
    else if (!/^\d{3,4}$/.test(fields.kvCode))
      errors.kvCode = "School Code must be a valid code.";
    if (!fields.nameOfKV.trim()) errors.nameOfKV = "Name of KV is required.";
    if (!fields.stateOfKV.trim())
      errors.stateOfKV = "State of KV School is required.";
    if (!fields.fullName.trim()) errors.fullName = "Full name is required.";
    if (!fields.educationQualification.trim())
      errors.educationQualification = "Education qualification is required.";
    if (!fields.gender) errors.gender = "Please select a gender.";
    if (!fields.contactNo.trim())
      errors.contactNo = "Contact number is required.";
    else if (!/^\d{10}$/.test(fields.contactNo))
      errors.contactNo = "Contact number must be 10 digits.";
    if (!fields.whatsappNo.trim())
      errors.whatsappNo = "WhatsApp number is required.";
    else if (!/^\d{10}$/.test(fields.whatsappNo))
      errors.whatsappNo = "WhatsApp number must be 10 digits.";
    if (!fields.emergencyContactNo.trim())
      errors.emergencyContactNo = "Emergency contact number is required.";
    else if (!/^\d{10}$/.test(fields.emergencyContactNo))
      errors.emergencyContactNo = "Emergency contact must be 10 digits.";
    // if (!fields.emailId.trim()) errors.emailId = "Email ID is required.";
    // else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.emailId))
    // errors.emailId = "Enter a valid email ID.";
    if (!fields.bloodGroup) errors.bloodGroup = "Blood group is required.";
    if (!fields.dateOfArrival)
      errors.dateOfArrival = "Date of arrival is required.";
    if (!fields.arrivalTime) errors.arrivalTime = "Arrival time is required.";
    if (!fields.dateOfDeparture)
      errors.dateOfDeparture = "Date of departure is required.";
    if (!fields.departureTime)
      errors.departureTime = "Departure time is required.";
    if (!fields.bringingLaptop)
      errors.bringingLaptop = "Please select an option.";
    if (!fields.hardwareKit)
      errors.hardwareKit = "Please select hardware kit option.";
    if (!fields.bringingPhotos)
      errors.bringingPhotos = "Please select an option.";
    if (!fields.mealPreference || fields.mealPreference.length === 0)
      errors.mealPreference = "Please select a meal preference.";
    // if (!fields.trainer) errors.trainer = "Please select trainer.";
    if (!fields.level) errors.level = "Please select a level.";
    if (!fields.domain) errors.domain = "Please select a domain.";
    if (!fields.course) errors.course = "Please select a course.";
    // if (!fields.relieving_Letter)
    //   errors.relieving_Letter = "Please attach the Relieving Letter";

    return errors;
  }

  // Auto-fill from the logged-in session on first load, so the teacher
  // doesn't have to retype details already known from login.
  useEffect(() => {
    const user = getLoggedInUser();
    if (!user) return;
    setLoggedInUser(user);
    setFields((f) => ({
      ...f,
      nameOfKV: f.fullName || user.name,
      email: f.email,
      emailId: f.emailId || user.email,
      contactNo: f.contactNo || phoneNumber,
      whatsappNo: f.whatsappNo || user.contactNo,
      kvCode: f.school_code || user.school_code,
    }));
  }, []);

  const set = (key) => (value) => {
    console.log(key, value);
    setFields((f) => ({ ...f, [key]: value }));
    setErrors((e) => ({ ...e, [key]: undefined }));
  };

  const toggleMeal = (val) => {
    console.log(val);
    setFields((f) => {
      const prev = f.mealPreference;
      return {
        ...f,
        mealPreference: val,
      };
    });
    setErrors((e) => ({ ...e, mealPreference: undefined }));
  };

  const handleSubmit = async () => {
    // setSubmitted(true);
    const errs = validate(fields);
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      const firstKey = Object.keys(errs)[0];
      const el = document.getElementById(firstKey);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setSubmitError("");
    setSubmitting(true);

    try {
      const token = localStorage.getItem("token");
      // Field names below match the API payload you shared (Key column).
      const formData = new FormData();
      formData.append("fullName", fields.fullName);
      formData.append("gender", fields.gender == "Male" ? "M" : "F");
      formData.append("bloodGroup", fields.bloodGroup);
      formData.append("emailId", fields.email);
      formData.append("contactNo", fields.contactNo);
      formData.append("whatsappNo", fields.whatsappNo);
      formData.append("emergencyContactNo", fields.emergencyContactNo);
      formData.append("state", fields.stateOfKV);
      formData.append("arrival_date", fields.dateOfArrival);
      formData.append("arrival_time", fields.arrivalTime);
      // formData.append("address", "address");
      // formData.append("city", "dehli");
      formData.append("departure_date", fields.dateOfDeparture);
      formData.append("departure_time", fields.departureTime);
      formData.append("bringing_laptop", fields.bringingLaptop === "Yes");
      formData.append("hardware_kit", "yes");
      formData.append("level", fields.level);
      formData.append("class", fields.domain);
      console.log("Course : ", fields.course)
      formData.append("combination_code", fields.course);
      // formData.append(
      //   "trainer",
      //   trainerUser?.filter((item) => item?.name == fields.trainer)[0]
      //     .employee_id,
      // );
      formData.append(
        "meal_preference",
        Array.isArray(fields.mealPreference)
          ? fields.mealPreference.join(",").toLowerCase()
          : String(fields.mealPreference).toLowerCase(),
      );
      formData.append("bring_two_photos", fields.bringingPhotos === "Yes");
      if (fields.relieving_Letter) {
        formData.append("relieving-letter", fields.relieving_Letter);
      }

      console.log(
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
        REGISTRATION_API_URL,
      );
      const response = await axios.post(REGISTRATION_API_URL, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.data?.success) {
        localStorage.setItem("login", "true");
        navigate("/");
      } else {
        toast.error("Registration failed. Please try again.");
        setSubmitError(
          response?.data?.message || "Registration failed. Please try again.",
        );
      }
    } catch (err) {
      console.log("Registration failed:", err.message);
      toast.error(err.message);
      setSubmitError(
        err?.response?.data?.message ||
        err.message ||
        "Registration failed. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleClear = () => {
    setFields(initialState);
    setErrors({});
    setSubmitted(false);
    setSubmitError("");
  };

  if (submitted) {
    return (
      <div className="online-page">
        <div className="online-success-card">
          <div className="online-success-icon">✓</div>
          <h2 className="online-success-title">Registration Submitted!</h2>
          <p className="online-success-text">
            A copy of your responses will be emailed to support@ihfc.co.in.
          </p>
          <div className="online-success-details">
            <p>
              <strong>Name:</strong> {fields.fullName}
            </p>
            <p>
              <strong>School Code:</strong> {fields.kvCode}
            </p>
            <p>
              <strong>KV Name:</strong> {fields.nameOfKV}
            </p>
            <p>
              <strong>Training Dates:</strong> June 23rd to 27th 2025
            </p>
            <p>
              <strong>Venue:</strong> MMTTC, JNU, New Delhi
            </p>
          </div>
          <button className="online-clear-btn" onClick={handleClear}>
            Thank you for submission
          </button>
        </div>
      </div>
    );
  }

  let local = localStorage.getItem("user");
  console.log(JSON.parse(local), "pressings");

  return (
    <div className="online-page">
      {/* Logged-in session banner */}

      {/* Title Card */}
      <div className="online-title-card">
        <h1 className="online-form-title">
          PM SHRI online ({JSON.parse(local)?.school_name})
        </h1>
        <div className="online-info-grid">
          {/* <InfoRow label="Dates" value="Feb, 23rd to 27th 2026" /> */}
          {/* <InfoRow
            label="For"
            value="PGT (PHY) teachers: Delhi and Gurgaon Region"
          /> */}
          {/* <InfoRow label="Training Dates" value="June, 23rd to 27th 2025" />
          <InfoRow label="Duration" value="5 days" />
          <InfoRow
            label="Venue"
            value="Malaviya Mission Teacher Training Centre (MMTTC), Jawaharlal Nehru University (JNU), New Delhi"
          /> */}
        </div>
        <div className="online-mandatory-box">
          <p className="online-mandatory-title">
            📋 Please bring the following mandatory items:
          </p>
          <ol className="online-mandatory-list">
            <li>Hardware Kit as given in the prerequisites link</li>
            <li>Laptop</li>
            <li>Two Passport Size photos for ID card</li>
          </ol>
        </div>
        <p className="online-note-text">
          <strong>Note:</strong> Due to limited accommodation, spouses and
          children are not permitted.
        </p>
      </div>

      <p className="online-required-note">* Indicates required question</p>

      <div className="online-card-grid">
        {/* Email input */}
        <div className="online-card">
          <FormInput
            id="email"
            type="email"
            label="Email"
            required
            // disabled
            placeholder="Your email"
            value={fields.email}
            onChange={set("email")}
            error={errors.email}
          />
        </div>

        {/* School Code */}
        <div className="online-card">
          <FormInput
            id="kvCode"
            type="text"
            label="School Code (3 Digit Code)"
            required
            disabled
            placeholder="Your answer"
            maxLength={4}
            value={fields.kvCode}
            onChange={set("kvCode")}
            error={errors.kvCode}
          />
        </div>

        {/* Name of KV */}
        <div className="online-card">
          <FormInput
            id="nameOfKV"
            type="text"
            label="Name"
            required
            disabled
            placeholder="Your answer"
            value={fields.nameOfKV}
            onChange={set("nameOfKV")}
            error={errors.nameOfKV}
          />
        </div>

        {/* State of KV School */}
        <div className="online-card">
          <FormInput
            id="stateOfKV"
            type="text"
            label="State of the School"
            required
            placeholder="Your answer"
            value={fields.stateOfKV}
            onChange={set("stateOfKV")}
            error={errors.stateOfKV}
          />
        </div>

        {/* Full Name */}
        <div className="online-card">
          <FormInput
            id="fullName"
            type="text"
            label="Full name as per Service record"
            required
            placeholder="Your answer"
            value={fields.fullName}
            onChange={set("fullName")}
            error={errors.fullName}
          />
        </div>

        {/* Education Qualification */}
        <div className="online-card">
          <FormInput
            id="educationQualification"
            type="text"
            label="Education Qualification with Specialization"
            required
            placeholder="Your answer"
            value={fields.educationQualification}
            onChange={set("educationQualification")}
            error={errors.educationQualification}
          />
        </div>

        {/* Gender */}
        <div className="online-card">
          <FormInput
            id="gender"
            type="select"
            label="Gender"
            required
            options={["Male", "Female", "Transgender"]}
            value={fields.gender}
            onChange={set("gender")}
            error={errors.gender}
          />
        </div>

        {/* Contact No */}
        <div className="online-card">
          <FormInput
            id="contactNo"
            type="tel"
            label="Contact no"
            required
            placeholder="Your answer"
            maxLength={10}
            value={fields.contactNo}
            disabled
            onChange={set("contactNo")}
            error={errors.contactNo}
          />
        </div>

        {/* WhatsApp No */}
        <div className="online-card">
          <FormInput
            id="whatsappNo"
            type="tel"
            label="Whatsapp No"
            required
            placeholder="Your answer"
            maxLength={10}
            value={fields.whatsappNo}
            onChange={set("whatsappNo")}
            error={errors.whatsappNo}
          />
        </div>

        {/* Emergency Contact */}
        <div className="online-card">
          <FormInput
            id="emergencyContactNo"
            type="tel"
            label="Emergency Contact No."
            required
            placeholder="Your answer"
            maxLength={10}
            value={fields.emergencyContactNo}
            onChange={set("emergencyContactNo")}
            error={errors.emergencyContactNo}
          />
        </div>

        {/* Email ID */}
        {/* <div className="online-card">
          <FormInput
            id="emailId"
            type="email"
            label="Email ID"
            required
            placeholder="Your answer"
            value={fields.emailId}
            onChange={set("emailId")}
            error={errors.emailId}
          />
        </div> */}

        {/* Blood Group */}
        <div className="online-card">
          <FormInput
            id="bloodGroup"
            type="select"
            label="Blood Group"
            required
            options={bloodGroups}
            value={fields.bloodGroup}
            onChange={set("bloodGroup")}
            error={errors.bloodGroup}
          />
        </div>

        {/* Date of Arrival */}
        <div className="online-card">
          <FormInput
            id="dateOfArrival"
            type="date"
            label="Date of Arrival at the Venue"
            required
            value={fields.dateOfArrival}
            onChange={set("dateOfArrival")}
            error={errors.dateOfArrival}
          />
        </div>

        {/* Arrival Time */}
        <div className="online-card">
          <FormInput
            id="arrivalTime"
            type="time"
            label="Arrival Time at the Venue"
            required
            value={fields.arrivalTime}
            onChange={set("arrivalTime")}
            error={errors.arrivalTime}
          />
        </div>

        {/* Date of Departure */}
        <div className="online-card">
          <FormInput
            id="dateOfDeparture"
            type="date"
            label="Date of Departure from the Venue"
            required
            value={fields.dateOfDeparture}
            onChange={set("dateOfDeparture")}
            error={errors.dateOfDeparture}
          />
        </div>

        {/* Departure Time */}
        <div className="online-card">
          <FormInput
            id="departureTime"
            type="time"
            label="Departure Time from the Venue"
            required
            value={fields.departureTime}
            onChange={set("departureTime")}
            error={errors.departureTime}
          />
        </div>

        {/* Bringing Laptop */}
        <div className="online-card">
          <FormInput
            id="bringingLaptop"
            type="select"
            label="I am bringing Laptop"
            required
            options={["Yes", "No"]}
            value={fields.bringingLaptop}
            onChange={set("bringingLaptop")}
            error={errors.bringingLaptop}
          />
        </div>

        {/* Hardware Kit */}
        <div className="online-card">
          <FormInput
            id="hardwareKit"
            type="select"
            label="I am bringing the Hardware kit as shared in prerequisites list"
            required
            options={["Yes", "I will purchase at the Training Centre"]}
            value={fields.hardwareKit}
            onChange={set("hardwareKit")}
            error={errors.hardwareKit}
          />
        </div>

        {/* Bringing Photos */}
        <div className="online-card">
          <FormInput
            id="bringingPhotos"
            type="select"
            label="I am bringing two passport size photos"
            required
            options={["Yes", "No"]}
            value={fields.bringingPhotos}
            onChange={set("bringingPhotos")}
            error={errors.bringingPhotos}
          />
        </div>

        {/* Meal Preference */}
        <div className="online-card">
          <div id="mealPreference">
            <FormInput
              type="select"
              id="mealPreference"
              label="Meal Preference"
              required
              options={["Veg", "Non-Veg"]}
              value={fields.mealPreference}
              onChange={(data) => toggleMeal(data)}
            />
          </div>
          {errors.mealPreference && (
            <p className="online-meal-error">{errors.mealPreference}</p>
          )}
        </div>
        <div className="online-card">
          <div id="relieving_Letter">
            <FormInput
              type="image"
              label="Relieving Letter"
              value={fields.relieving_Letter}
              onChange={set("relieving_Letter")}
            />
          </div>
          {errors.relieving_Letter && (
            <p className="online-meal-error">{errors.relieving_Letter}</p>
          )}
        </div>
        {/* <div className="online-card">
          <FormInput
            id="trainer"
            type="select"
            label="Select Trainer"
            required
            options={trainerUser.map((item) => item.name)}
            value={fields.trainer}
            onChange={set("trainer")}
            error={errors.trainer}
          />
        </div> */}

        {/* Level */}
        <div className="online-card">
          <FormInput
            id="level"
            type="select"
            label="Select Level"
            required
            options={[...new Set(categories.map((item) => item.level))]}
            value={fields.level}
            onChange={handleLevelChange}
            error={errors.level}
          />
        </div>

        {/* Domain / Class */}
        <div className="online-card">
          <FormInput
            id="domain"
            type="select"
            label="Select Domain"
            required
            disabled={!fields.level || loadingDomains}
            options={domains.map((item) => item.class)}
            value={fields.domain}
            onChange={handleDomainChange}
            error={errors.domain}
          />
        </div>

        {/* Course */}
        <div className="online-card">
          <FormInput
            id="course"
            type="select"
            label="Select Course"
            required
            disabled={!fields.domain || loadingCourses}
            options={courses.map((item) => item.course_list)}
            value={
              courses.find(
                (item) => item.combination_code === fields.course
              )?.course_list || ""
            }
            onChange={(selectedCourseName) => {
              const selectedCourse = courses.find(
                (item) => item.course_list === selectedCourseName
              );

              setFields((f) => ({
                ...f,
                course: selectedCourse?.combination_code || "",
              }));

              setErrors((e) => ({
                ...e,
                course: undefined,
              }));
            }}
            error={errors.course}
          />
        </div>
      </div>

      {submitError && (
        <p className="online-meal-error" style={{ textAlign: "center" }}>
          {submitError}
        </p>
      )}

      {/* Submit */}
      <p className="online-copy-note">
        A copy of your responses will be emailed to support@ihfc.co.in.
      </p>
      <div className="online-submit-row">
        <button
          className="online-submit-btn"
          onClick={handleSubmit}
          disabled={submitting}
        >
          {submitting ? "Submitting..." : "Submit"}
        </button>
        <button
          className="online-clear-btn"
          onClick={handleClear}
          disabled={submitting}
        >
          Clear form
        </button>
      </div>

      <p className="online-footer">
        Never submit passwords through Google Forms.
      </p>
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <p className="online-info-row">
      <strong>{label}:</strong> {value}
    </p>
  );
}
